import { render, staticRenderFns } from "./BlackPearlHome.vue?vue&type=template&id=0927b6d1&"
import script from "./BlackPearlHome.vue?vue&type=script&lang=ts&"
export * from "./BlackPearlHome.vue?vue&type=script&lang=ts&"
import style0 from "./BlackPearlHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports